/**
 *
 * getSagasConfig Function
 *
 */

export default function getSagasConfig(accountId) { return {} }
